import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Postback} from '../../models/postback/postback';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class PostbackService extends AbstractModelService<Postback> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/postback', Postback);
  }

  fetchVariables(): Observable<string[]> {
    return new Observable<string[]>((subscriber) => {
      this.apiClient.get('/postback/variables').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['variables']);
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
